module.exports = __webpack_public_path__ + "/static/assets/4cfb617bd5ddb3963da6bdc2a814d06c.gif";